document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('#CartDrawer'); // or another static parent
  const prioToggle = document.querySelector('#ck-prio-product-toggle');
  const variantDataEl = document.querySelector('[data-ck-prio-product]');
  const prioContainer = document.querySelector('.ck-prio-product__toggle');

  // --- helpers ---
  async function getPrioVariantId() {
    if (!variantDataEl || !prioContainer) return null;
    try {
      const selectedTitle = prioContainer.dataset.variant;
      const variants = JSON.parse(variantDataEl.textContent || '[]');
      const match = variants.find(v => v.title === selectedTitle);
      return match ? match.id : null;
    } catch {
      return null;
    }
  }

  async function ensurePrioNotAlone() {
    try {
      const prioVariantId = await getPrioVariantId();
      if (!prioVariantId) return;

      const cart = await fetch('/cart.js').then(r => r.json());
      if (!Array.isArray(cart.items)) return;

      const prioItem = cart.items.find(i => i.variant_id === prioVariantId);

      // If the cart has only 1 item and it's the prio product, remove it.
      if (prioItem && cart.items.length === 1) {
        console.log('Removing priority product because it is the only item left...');
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: prioItem.key, quantity: 0 })
        });
      }
    } catch (err) {
      console.warn('ensurePrioNotAlone failed:', err);
    }
  }

  // 🔧 Patch fetch so any cart mutation triggers a check afterwards
  (function patchCartFetch() {
    const origFetch = window.fetch;
    window.fetch = async function patchedFetch(input, init = {}) {
      const res = await origFetch(input, init);
      try {
        const url = typeof input === 'string' ? input : input?.url || '';
        const method = (init?.method || 'GET').toUpperCase();
        const isCartMutation =
          method !== 'GET' &&
          (/\/cart\/add\.js$|\/cart\/change\.js$|\/cart\/update\.js$/.test(url));

        if (isCartMutation) {
          // Tiny delay so the cart state reflects the mutation
          setTimeout(ensurePrioNotAlone, 60);
        }
      } catch { /* noop */ }
      return res;
    };
  })();

  // Run once on load in case drawer renders a stale cart
  ensurePrioNotAlone();

  // --- your existing toggle removal (unchanged) ---
  if (prioToggle && variantDataEl && prioContainer) {
    prioToggle.addEventListener('change', async function () {
      if (prioToggle.checked) return; // ✅ Do nothing if re-checked

      try {
        const selectedTitle = prioContainer.dataset.variant;
        const variants = JSON.parse(variantDataEl.textContent);
        const match = variants.find(v => v.title === selectedTitle);
        if (!match) return;

        const prioVariantId = match.id;
        const cart = await fetch('/cart.js').then(res => res.json());
        const itemInCart = cart.items.find(item => item.variant_id === prioVariantId);

        if (itemInCart) {
          console.log('Removing priority product from cart...');
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: itemInCart.key, quantity: 0 })
          });
        }
      } catch (error) {
        console.error('Error removing priority product:', error);
      }
    });
  }

  // --- your existing checkout handler (unchanged) ---
  document.addEventListener('click', async (e) => {
    const checkoutButton = e.target.closest('#CartDrawer-Checkout');
    if (!checkoutButton) return;
  
    e.preventDefault();
    console.log('[Prio Checkout] Checkout clicked');
  
    const prioToggle = document.querySelector('#ck-prio-product-toggle');
    const variantDataEl = document.querySelector('[data-ck-prio-product]');
    const prioContainer = document.querySelector('.ck-prio-product__toggle');
  
    if (!prioToggle || !prioToggle.checked || !prioContainer || !variantDataEl) {
      console.log('[Prio Checkout] No active prio toggle → direct checkout');
      window.location.href = '/checkout';
      return;
    }
  
    try {
      // Find prio variant ID
      const variants = JSON.parse(variantDataEl.textContent || '[]');
      const selectedTitle = prioContainer.dataset.variant;
      const match = variants.find(v => v.title === selectedTitle);
      const prioVariantId = match ? match.id : null;
  
      if (!prioVariantId) {
        console.warn('[Prio Checkout] Could not resolve prio variant → direct checkout');
        window.location.href = '/checkout';
        return;
      }
  
      // Check current cart
      const cart = await fetch('/cart.js').then(r => r.json());
      const prioInCart = cart.items.filter(i => i.properties && i.properties._isPrio);
  
      console.log('[Prio Checkout] Cart before checkout:', cart.items);
      console.log('[Prio Checkout] Found prioInCart:', prioInCart);
  
      // If there’s a prio item but without property, or multiple, clean it up
      for (const item of prioInCart) {
        if (!item.properties._isPrio) {
          console.log('[Prio Checkout] Removing stale prio item', item.key);
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        }
      }
  
      // Check again after cleanup
      const freshCart = await fetch('/cart.js').then(r => r.json());
      const alreadyInCart = freshCart.items.some(
        i => i.variant_id === prioVariantId && i.properties && i.properties._isPrio
      );
  
      if (!alreadyInCart) {
        console.log('[Prio Checkout] Adding prio item…');
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: prioVariantId, quantity: 1, properties: { _isPrio: true } })
        });
  
        // Small delay to let Shopify sync
        await new Promise(res => setTimeout(res, 300));
      } else {
        console.log('[Prio Checkout] Prio already in cart with _isPrio = true');
      }
  
      // ✅ proceed to checkout
      window.location.href = '/checkout';
  
    } catch (err) {
      console.error('[Prio Checkout] Failed:', err);
      window.location.href = '/checkout'; // fallback
    }
  });
  
});